import {Injectable} from '@angular/core';
import {TenureModalComponent} from './tenure-modal.component';
import {ModalService} from '../modal-service.service';
import {FormerTenureValidity} from '../../../models/former-tenure-validity.model';
import {FormerTenureUiConfig} from '../../../models/former-tenure-ui-config';
import {ParentPlanType} from '../../../models/parent-plan-type.model';
import {SubjectLandType} from '../../../models/subject-land-type.model';

export interface TenureModalProps {
    tenureDisplayType: string;
    formerTenureValidityLookup: FormerTenureValidity;
    formerTenureUIConfigLookup: FormerTenureUiConfig;
    parentPlanTypeLookups: ParentPlanType[];
    subjectLandTypeLookups: SubjectLandType[];
}

@Injectable({
    providedIn: 'root'
})
export class TenureModalService extends ModalService {
    showModal(props: TenureModalProps) {
        this.createModalComponent(TenureModalComponent);
        const tenureModalComponentInstance = this.modalComponentRef.instance as TenureModalComponent;
        tenureModalComponentInstance.tenureDisplayType = props.tenureDisplayType;
        tenureModalComponentInstance.parentPlanTypeLookups = props.parentPlanTypeLookups;
        tenureModalComponentInstance.subjectLandTypeLookups = props.subjectLandTypeLookups;
        tenureModalComponentInstance.formerTenureValidityLookup = props.formerTenureValidityLookup;
        tenureModalComponentInstance.formerTenureUIConfigLookup = props.formerTenureUIConfigLookup;
        this.showModalComponent();
        return tenureModalComponentInstance.modalClosed;
    }
}
